import "bootstrap"
import "./datepicker/bootstrap-datepicker.js"
import "./datepicker/bootstrap-datepicker.cs.js"
import "./jscolor.js"
import "./netteForms.js"
import "./nette.ajax.js"
import "./confirm.dialog.js"

// kde jsou sluzby na validaci? - to by mi cilove mela naplnit aplikace, podle toho jak ma nastavene routovani
var denInfoUrl = "/default/json-den";
var overUrl = "/default/json-over";

var osaObj = {
    validOd: "",
    errMessage: "Vyplňte rezervační formulář",
    // presun se na jiny den - a vypis o nem info
    changeDay: function (program, datum) {
        $.ajax({
            url: denInfoUrl,
            data: {
                program: program,
                datum: datum,
            },
            type: "POST",
            dataType: "json",
            success: function (data) {
                osaObj.renderOsa(data.lektori, data.otevreno, data.state);
                osaObj.renderObsazenost(data.obsazenost, data.lektori);
                $("#frm-vyberForm-zacatek").trigger("change");
            },
            error: function (jqXHR, textStatus, errorThrown) {
                alert("Chyba v načítání kelandáře: " + errorThrown);
            }
        });
    },
    // over zvoleny termin na rezervaci
    // odebrany posledni parametr ,waitForResult - je to deprecated
    rezervuj: function (program, datum, casStart, pocetLidi) {
        this.errMessage = "";
        $.ajax({
            url: overUrl,
            //async: !waitForResult,
            data: {
                program: program,
                datum: datum,
                cas: casStart,
                lidi: pocetLidi,
            },
            type: "POST",
            dataType: "json",
            success: function (data) {
                osaObj.renderRezervace(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                ;//alert("Chyba v rezervaci: " + errorThrown);
            }
        });
    },
    // nakresli casovou osu
    renderOsa: function (lektori, otevreno, state) {
        $("#div-rozvrh").empty();
        if ((typeof lektori !== 'undefined') && (lektori.length > 0)) {
            $("#div-rozvrh").html("<table class='table table-bordered table-hover' id='table-rozvrh'><tbody></tbody></table>");
            var table = $("#table-rozvrh");
            var hodtr = "<tr class='cas'><td></td>";
            for (var i = otevreno.odIndex; i < otevreno.doIndex; i++) {
                if (i % 2 == 0) {
                    hodtr += "<td colspan='2' class='hodiny'>" + (i / 2) + ":00</td>";
                }
            }
            hodtr += '</tr>';
            table.append(hodtr);
            var counter = 0;
            $.each(lektori, function (key, lektor) {

                //console.log("renderOsa - lektor "+lektor.id );
                var tds = "<tr id='lektor" + counter + "'>";
                tds += "<td>" + lektor.nazev + "</td>";
                for (var i = otevreno.odIndex; i < otevreno.doIndex; i++) {
                    tds += "<td class='osa volno' data-casindex='" + (i) + "'></td>";
                }
                tds += '</tr>';
                table.append(tds);
                counter++;
            });
        } else {
            var chyba = "Nelze provést rezervaci";
            if (state.length > 0) chyba = osaObj.translateErr(state);
            $("#div-rozvrh").html("<div class='alert alert-danger' role='alert'>" + chyba + "</div>");
        }
    },
    // nakresli v casove ose, kdy je uz obsazeno
    renderObsazenost: function (obsazenost, lektori) {

        if ((typeof obsazenost !== 'undefined') && (obsazenost.length > 0)) {

            var table = $("#table-rozvrh");
            var counter = 0;
            var last_uroven = 0;
            $.each(obsazenost, function (key, okno) {
                // vypis pro kazdou uroven to svoje
                if (okno.level == last_uroven) { // je li stejna uroven, dej to do jedne radky (counter zustane stejny)
                    for (var i = okno.zacatekIndex; i < okno.konecIndex; i++) {
                        $("#lektor" + (lektori.length - 1 - counter) + " td[data-casindex='" + i + "']").toggleClass("volno obsazeno");
                    }
                } else { //je-li jina uroven, dej to o jednu vys a zvys counter pro pristi prvek
                    counter++;
                    last_uroven++;
                    for (var i = okno.zacatekIndex; i < okno.konecIndex; i++) {
                        $("#lektor" + (lektori.length - 1 - counter) + " td[data-casindex='" + i + "']").toggleClass("volno obsazeno");
                    }

                }


            });
        }
        osaObj.catchClicks();
    },
    // nakresli zvolenou rezervaci do casove osy - ZELENY VYBER
    renderRezervace: function (overeni) {
        if (overeni.state.length > 0) {
            alert(osaObj.translateErr(overeni.state));
        } else {
            // nedriv vsechno vybrane odeber
            $("#table-rozvrh .vybrano").toggleClass("volno vybrano");
            // projdi lektory, ktere si vybral a kazdemu zapis obsazenost
            var counter = 0;
            $.each(overeni.lektori, function (key, lektor) {
                for (var i = overeni.obsazenost.odIndex; i < overeni.obsazenost.doIndex; i++) {
                    //console.log("renderObsazenost - lektor "+ lektor.id +" - "+i);
                    $("#lektor" + counter + " td[data-casindex='" + i + "']").toggleClass("volno vybrano");
                }
                counter++;
            });
            this.validOd = overeni.obsazenost.od;
            $("#frm-vyberForm-konec").val(overeni.obsazenost.do);
        }
        $("#frm-vyberForm-zacatek").val(this.validOd);
    },
    // preloz chybove kody do cestiny - nebudou potreba jine jazyky?
    translateErr: function (state) {
        var retval = "";
        if (state.length > 0) {
            switch (state) {
                case "nopeople":
                    retval = "Nejdřídve zadejte prosím počet lidí!";
                    break;
                case "lowlektors":
                    retval = "Ve zvolený čas nelze provést rezervaci,  všichni naši lektoři jsou již obsazeni. Zvolte prosím jinou hodinu nebo termín.";
                    break;
                case "toomuch":
                    retval = "Nelze provést rezervaci to takto početnou skupinu";
                    break;
                case "zavreno":
                    retval = "Požadovaný den nelze rezervovat";
                    break;
                case "uzavirka":
                    retval = "Požadovaný den nelze rezervovat";
                    break;
                case "offline":
                    retval = "Vybraný program nelze online rezervovat";
                    break;
                case "outhours":
                    retval = "Na zvolenou hodinu nelze rezervovat";
                    break;
                default:
                    retval = "Nelze provést rezervaci";
            }
        }
        this.errMessage = retval;
        return retval;
    },
    // co vsechno mam zachytavat?
    catchClicks: function () {
        $("#table-rozvrh .osa").click(function (event) {
            event.preventDefault();
            if ($(this).hasClass("volno")) {
                // zkus udelat rezervaci (a pak zmen class na vybrano)
                osaObj.rezervuj($('#frm-vyberForm-id_program').val(), $('.datepicker').datepicker("getUTCDate").toJSON(), $(this).data("casindex"), $('#frm-vyberForm-pocet_lidi').val());
                //$(this).toggleClass("volno vybrano");
            } else if ($(this).hasClass("vybrano")) {
                // rezervaci delam vzdy jen jednu, tak bych mohl všechno odvybrat
                $("#table-rozvrh .vybrano").toggleClass("volno vybrano");
                this.validOd = ""
                $("#frm-vyberForm-zacatek").val(this.validOd);
                $("#frm-vyberForm-konec").val("");

            }
        });
    },
}
// -------------------------------------------------------------------
var myApp;
myApp = myApp || (function () {
    var pleaseWaitDiv = $('<div class="modal hide" id="pleaseWaitDialog" data-backdrop="static" data-keyboard="false"><div class="modal-header"><h1>Processing...</h1></div><div class="modal-body"><div class="progress progress-striped active"><div class="bar" style="width: 100%;"></div></div></div></div>');
    return {
        showPleaseWait: function () {
            pleaseWaitDiv.modal();
        },
        hidePleaseWait: function () {
            pleaseWaitDiv.modal('hide');
        },

    };
})();
// -------------------------------------------------------------------
$(function () {
    $.nette.init();

    // zobraz nacitani ajaxu
    // https://blog.oio.de/2010/11/08/how-to-create-a-loading-animation-spinner-using-jquery/
    $('#div-progress').hide().append("<div class='text-center panel panel-default jumbotron flyover flyover-centered'><p><span class='glyphicon glyphicon-refresh' aria-hidden='true'></span> kontrola kalendáře</p></div>");
    $(document).ajaxStart(function () {
        $('#div-progress').show();
    });
    $(document).ajaxStop(function () {
        $('#div-progress').hide();
    });

    if ($().datepicker) {
        // vykresli kalendar
        $('.datepicker').datepicker({
            language: "cs",
        });
        $(".datepicker").attr("autocomplete", "off")
        // zobraz kalendar
        // na rezervacnim formulari nastav fungovani
        if ($('#frm-vyberForm').length > 0) {
            $('.datepicker').on("changeDate", function (e) {
                osaObj.changeDay($('#frm-vyberForm-id_program').val(), $('.datepicker').datepicker("getUTCDate").toJSON());
            });
            //$('.datepicker').change(function () {
            //osaObj.changeDay($('#frm-vyberForm-id_program').val(),$('.datepicker').datepicker("getUTCDate").toJSON());
            //});
            $('#frm-vyberForm-id_program').change(function () {
                osaObj.changeDay($('#frm-vyberForm-id_program').val(), $('.datepicker').datepicker("getUTCDate").toJSON());
            });
            $('#frm-vyberForm-pocet_lidi').change(function () {
                osaObj.changeDay($('#frm-vyberForm-id_program').val(), $('.datepicker').datepicker("getUTCDate").toJSON());
            });
            // reaguj na zacatek
            $("#frm-vyberForm-zacatek").change(function () {
                osaObj.errMessage = "Vyplňte rezervační formulář";
                if ($('#frm-vyberForm-pocet_lidi').val().length > 0) {
                    // jen pokud je platny cas
                    var zacatek = $(this).val();
                    if (zacatek.length > 0) {
                        let re = /^\d{1,2}:\d{2}?$/;
                        if (zacatek.match(re)) {
                            if (zacatek.length == 4) zacatek = '0' + zacatek;
                            var zacatekIndex = parseInt(zacatek.substring(0, 2)) * 2;
                            if (parseInt(zacatek.substring(3, 5)) >= 30) zacatekIndex += 1;
                            // pozor tohle vola ajax a zakazovani async je deprecated
                            // pokud se rezervace nepovede - mela by se vratit puvodni hodnota
                            /*
                            if (!osaObj.rezervuj($('#frm-vyberForm-id_program').val(),$('.datepicker').datepicker("getUTCDate").toJSON(),zacatekIndex,$('#frm-vyberForm-pocet_lidi').val(),true)) {
                              console.log("zmena se nepovedla - vrat puvodni hodnotu, pokud byla - mohla by byt v tabulce");
                            } */
                            osaObj.rezervuj($('#frm-vyberForm-id_program').val(), $('.datepicker').datepicker("getUTCDate").toJSON(), zacatekIndex, $('#frm-vyberForm-pocet_lidi').val());
                        } else {
                            alert("Zadejte začátek ve formátu hh:mm");
                            $(this).focus();
                        }
                    }
                }
            });
            $("#frm-vyberForm").submit(function (event) {
                // console.log("validate form - !!!wait for async");
                $("#frm-vyberForm-zacatek").trigger("change");
                if (osaObj.errMessage == "") {
                    return;
                } else {
                    alert(osaObj.errMessage);
                    //
                }
                event.preventDefault();
            });
            // konec nelze editovat
            $("#frm-vyberForm-konec").prop('readonly', 'readonly');
            // uvodni nastaveni data v kalendari - jen pokud tam zadny datum zatim neni....
            if ($('.datepicker').val() == '') {
                // vychozi datum v kalendari bude zitrek
                var startDatum = new Date();
                var zaKolikDni = 1;
                // pokud je zitra vikend, tak nabidni rovnou pondeli
                if (startDatum.getDay() == 5) zaKolikDni += 2;
                if (startDatum.getDay() == 6) zaKolikDni += 1;
                startDatum.setDate(startDatum.getDate() + zaKolikDni);
                $('.datepicker').datepicker('update', startDatum);
            }
            osaObj.changeDay($('#frm-vyberForm-id_program').val(), $('.datepicker').datepicker("getUTCDate").toJSON());
        }
    }
});
